import { render } from "./PhoneNumberInput.vue?vue&type=template&id=2ec9b022&scoped=true"
import script from "./PhoneNumberInput.vue?vue&type=script&lang=ts"
export * from "./PhoneNumberInput.vue?vue&type=script&lang=ts"

import "./PhoneNumberInput.vue?vue&type=style&index=0&id=2ec9b022&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2ec9b022"

export default script